import { Component, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-change-filter-page',
  templateUrl: './change-filter-page.component.html',
  styleUrls: ['./change-filter-page.component.scss']
})
export class ChangeFilterPageComponent implements OnInit {
  showBackButton: any = true
  headerTitle = 'Select Filters'
  checkBox_color='red'

  itemsObject = [
    {
      id: 1,
      val: 'Organization 1',
      selected: false
    },
    {
      id: 2,
      val: 'Organization 2',
      selected: false
    }
  ];

  programCheckbox = [
    {
      id: 1,
      val: 'Program 1',
      selected: false
    },
    {
      id: 2,
      val: 'Program 2',
      selected: false
    }, {
      id: 3,
      val: 'Program 3',
      selected: false
    }, {
      id: 4,
      val: 'Program 4',
      selected: false
    }, {
      id: 5,
      val: 'Program 5',
      selected: false
    }, {
      id: 6,
      val: 'Program 6',
      selected: false
    }, {
      id: 7,
      val: 'Program 7',
      selected: false
    }, {
      id: 8,
      val: 'Program 8',
      selected: false
    }, {
      id: 9,
      val: 'Program 9',
      selected: false
    }, {
      id: 10,
      val: 'Program 10',
      selected: false
    }
  ]

  allCheckboxSelected: any;



  constructor() { }

  ngOnInit(): void {
  }

  toggleAll(event: MatCheckboxChange) {
    if (event.checked) {
      this.itemsObject.forEach(element => {
        element.selected = true;
      });
    } else {
      this.itemsObject.forEach(element => {
        element.selected = false;
      });
    }
  }

  isChecked() {
    this.allCheckboxSelected =
      this.itemsObject.length != 0 && this.itemsObject.every(el => el.selected);
    return this.allCheckboxSelected;
  }

  isIndeterminate() {
    if (this.itemsObject.length === 0) {
      return false;
    }
    return (
      this.itemsObject.some(el => el.selected) && !this.allCheckboxSelected
    );
  }

  toggle(checkbox: any) {
    let index = this.itemsObject.findIndex(el => el.id === checkbox.id);
    this.itemsObject[index].selected = !this.itemsObject[index].selected;
  }

  exists(item: any) {
    let index = this.itemsObject.findIndex(el => el.id === item.id);
    return this.itemsObject[index].selected;
  }
 

}
